// src/apis/lessonsApis.ts

import { apiAxios } from "./api-config/apiConfig";

/* =====================================================
   TYPES
===================================================== */

export interface LessonTypeDetail {
  lessonFileId: string;
  lessonUrl: string;
}

export interface OtherAttachment {
  attachmentUrl?: string;
  attachmentType: "video" | "document" | "website";
  attachmentDuration?: string;
  attachmentFileId?: string;
  attachmentFileUrl?: string;
}

export interface CategoryMapped {
  id: string;
  name: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface LessonDetails {
  id: string;
  name: string;
  description: string;
  lessonType: "video" | "document" | "website";
  lessonTypeDetails: LessonTypeDetail[];
  otherAttachments: OtherAttachment[];
  isActive: boolean;
  lessonLongDescription: string;
  weekId: string;
  buttonName: string;
  weekName: string;
  categoriesMapped: CategoryMapped[];
  isCompleted: boolean;
  relatedResource: any;
}

export interface LessonDetailsResponse {
  status: boolean;
  data: LessonDetails;
}

/* =====================================================
   API FUNCTION
===================================================== */

export const getLessonDetailsApi = async (
  lessonId: string,
): Promise<LessonDetailsResponse> => {
  const response = await apiAxios.get<LessonDetailsResponse>(
    `/lesson/${lessonId}`,
  );

  return response.data;
};

/* =====================================================
   MARK LESSON COMPLETED
===================================================== */

export interface MarkLessonCompletedPayload {
  isCompleted: boolean;
}

export interface MarkLessonCompletedResponse {
  status: boolean;
  data: string; // "Lesson marks as completed."
}

export const markLessonCompletedApi = async (
  lessonId: string,
  payload: MarkLessonCompletedPayload,
): Promise<MarkLessonCompletedResponse> => {
  const response = await apiAxios.put<MarkLessonCompletedResponse>(
    `/lesson/${lessonId}`,
    payload,
  );

  return response.data;
};
